import { Token } from '@/src/models';
import { OrderParameter } from './order-parameter';

type OrderParametersProps = {
  quoteToken: Token;
  baseToken: Token;
};

export const OrderParameters = ({ quoteToken, baseToken }: OrderParametersProps) => {
  return (
    <>
      <OrderParameter title="limitPrice" formName="limitPrice" token={quoteToken} />
      <OrderParameter title="quantity" formName="quantity" token={baseToken} />
      <OrderParameter title="totalPrice" formName="total" token={quoteToken} />
    </>
  );
};
